import React from 'react';
import FormHistory from 'modules/FormHistory';

const Transactions = ({ contact, portfolioUuid, profileUuid }) => {
  const isCompany = contact.type === 'COMPANY';
  const key = isCompany
    ? 'c_da_transactions'
    : 'p_da_transactions';

  return <FormHistory
    formKey={key}
    contactName={contact.name}
    portfolioUuid={portfolioUuid}
    profileUuid={profileUuid}
  />;
};

export default Transactions;
